import React, { useState, useEffect, Fragment } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import CustomerListTable from "../customer/CustomerListTable";
import CustomerDelegationHeader from "./CustomerDelegationHeader";
import { useFetchCustomerTableDelegationQuery } from "../../utils/customer/customerTaskTable";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import useFullscreen from "../../hooks/Screen/FullCloseScreen";
import { useDispatch } from "react-redux";
import { DELETE_CUSTOMER_DELEGATION } from "../../utils/constants";
import { deleteData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { useParams } from "react-router-dom";
import AddUpdateDelegation from "./AddUpdateDelegation";
import { Dialog, Tooltip } from "@mui/material";
import { pushAlert } from "../../utils/alertSlice";
import UserHoverDetails from "../User/UserHoverDetails";
import { parseJSONValue } from "../../utils/json/parseJSONValue";
import { useUpdateUserActiveMutation } from "../../utils/customer/customerTaskTable";
import { ReactComponent as ActiveIcon } from "../../assets/images/handleToggleUserActiveIcon.svg";
import { ReactComponent as InActiveIcon } from "../../assets/images/handleToggleUserActiveIcon copy.svg";
import CustomerShowDetails from "./CustomerShowDetails";
import AddUserModal from "../User/AddUserModal";
import Loader from "../UniversalComponents/Loader";
import { hideLoader, showLoader } from "../../utils/loaderSlice";

import PlusIcon from "../../assets/images/icons/PlusIcon";

const ManageAccess = () => {
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const { isFullscreen, toggleFullscreen } = useFullscreen();
  const [customer, setCustomer] = useState([]);
  const [initialFilter, setInitialFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useRequireAuth();
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [editData, setEditData] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { id: customerId } = useParams();
  const [totalData, setTotalData] = useState();
  const [showHoverId, setShowHoverId] = useState(null);
  const [openShowDetails, setOpenShowDetails] = useState(false);
  const [SelecteduserId, setSelecteduserId] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const {
    data: customerTableALL,
    refetch: refetchCustomerData,
    isFetching,
  } = useFetchCustomerTableDelegationQuery({
    token: token,
    pagination: `${customerTablePagination}`,
    customerId: customerId,
  });

  const [
    updateUserActive,
    { isLoading: isUpdating, isSuccess: isUpdateSuccess, isError: isUpdateError, error: updateError },
  ] = useUpdateUserActiveMutation();

  useEffect(() => {
    if (customerTableALL) {
      const { data, ...restData } = customerTableALL?.data;
      setCustomer(data);
      setInitialFilter(restData);
      setLoading(false);
      setTotalData(customerTableALL?.data?.total);
    }
  }, [customerTableALL, customerTablePagination, refetchCustomerData]);

  const dispatch = useDispatch();

  const handleNavigate = (taskid) => {
    setEditData(taskid);
  };
  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };
  const onClose = () => {
    setIsPopupOpen(false);
    setEditData("");
  };

  const handelRegenerat = () => {
    refetchCustomerData();
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const handleDelete = async (rowKey, item) => {
    const id = item?.customer_id?.value;
    const url = `${DELETE_CUSTOMER_DELEGATION}${id}`;
    const response = deleteData(url, token);
    if (response) {
      refetchCustomerData();
      // setAlert({
      //   visible: true,
      //   message: "User deleted successfully",
      //   type: "success",
      // });
      dispatch(
        pushAlert({ message: response?.message || "User deleted successfully", type: "success", visible: true })
      );
    }
  };

  const handleShowHover = (data, header) => {
    setShowHoverId({ data, header });
  };

  const isHoverDetailsOpen = (item, header) => {
    const customerIdMatches = showHoverId?.data?.customer_id?.value === item?.customer_id?.value;
    const headerKeyMatches = showHoverId?.header?.key === header?.key;

    return customerIdMatches && headerKeyMatches;
  };

  const handleShowDetails = (value, headerKey) => {
    console.log(value, headerKey, "vivkManageAccess");
    setOpenShowDetails(value && { customerData: value, headerKey });
  };

  useEffect(() => {
    dispatch(isUpdating ? showLoader() : hideLoader());
  }, [isUpdating]);

  const handleToggleUserActive = async (data) => {
    const payload = {
      id: data?.customer_id?.value,
      status: data?.enabled_status?.value == 1 ? 0 : 1,
    };
    try {
      await updateUserActive({ token, data: payload });
      dispatch(pushAlert({ message: "User updated successfully!", type: "success", visible: true }));
    } catch (err) {
      dispatch(pushAlert({ message: "Something went wrong.", type: "error", visible: true }));
    }
  };

  const handleEditModalClick = (userId) => {
    setSelecteduserId(userId);
  };

  const closeUEPopup = () => {
    setSelecteduserId(null);
  };

  const [ticker, setTicker] = useState(0);
  useEffect(() => {
    if (isFetching) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isFetching]);

  return (
    <Fragment>
      <div className="h-full" id="innercontent">
        <div id="default-styled-tab-content" className="tablemaindiv h-full">
          <div className="profile h-full" id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
            <div className={` ${isFullscreen ? "bg-white h-full" : "h-full"}`}>
              {/* <div className="flex items-center gap-2">
                <div className="tablemaindiv customerTaskTable py-1">
             
                </div>
              </div> */}

              <CustomerListTable
                tableDetail={{
                  tableidclass: "fullscreen-table",
                  tableparentidclass: "tableparent",
                  tablename: <div className="mb-1">Manage Access</div>,
                  tablenameclass: "font-medium text-537596 capitalize",
                  tableSearch: true,
                  tableFilter: true,
                  tableResizer: true,
                  tableZoom: true,
                  tableheader: false,
                  dataactivity: true,
                  forcefullyfreeze: true,
                  datetedata: true,
                  headeraddfield: false,
                  rowDisable: true,
                  addbutton: (
                    <Tooltip
                      placement="top"
                      title="Add"
                      PopperProps={{
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, -5],
                            },
                          },
                        ],
                      }}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "black",
                            color: "white",
                            boxShadow: "none",
                            height: "23px",
                            display: "flex",
                            alignItems: "center",
                          },
                        },
                      }}
                    >
                      <button onClick={openPopup} type="button" className="text-2541558A hover:text-254155">
                        <PlusIcon isActive={isPopupOpen} isHovered={isHovered} />
                      </button>
                    </Tooltip>
                  ),
                  tableHeading: "Manage Access",
                }}
                thead={CustomerDelegationHeader}
                tbody={customer}
                totalData={totalData}
                tablePaginationData={setCustomerTablePagination}
                initialFilter={initialFilter}
                handleNavigate={handleNavigate}
                navigateNameCondition={["user_name", "action"]}
                handleDelete={handleDelete}
                handleShowDetails={handleShowDetails}
                openShowDetails={openShowDetails}
                ExtraFieldComponent={{
                  user_name: (item, header) => (
                    <div
                      className="absolute w-full h-full left-2 top-2"
                      onMouseOver={() => handleShowHover(item, header)}
                      onMouseOut={() => handleShowHover(null)}
                    >
                      <div>
                        <UserHoverDetails
                          open={isHoverDetailsOpen(item, header)}
                          onClose={() => handleShowHover(null)}
                          item={item}
                          header={header}
                          handleShowDetails={handleShowDetails}
                          handleShowHover={handleShowHover}
                          disableShowMore
                        />
                      </div>
                    </div>
                  ),
                  reporting: (item, header) => (
                    <div
                      className="absolute w-full h-full"
                      onMouseOver={() => handleShowHover(item, header)}
                      onMouseOut={() => handleShowHover(null)}
                    >
                      <div>
                        <UserHoverDetails
                          open={isHoverDetailsOpen(item, header)}
                          onClose={() => handleShowHover(null)}
                          item={item}
                          header={header}
                          handleShowDetails={handleShowDetails}
                          handleShowHover={handleShowHover}
                        />
                      </div>
                    </div>
                  ),
                  enabled: (item, header, tableDetail) => {
                    const parsedData = parseJSONValue(item);
                    return (
                      <div className={`absolute -top-[10px]`} key={item?.id}>
                        <label className={`inline-flex cursor-pointer`}>
                          <input
                            key={item?.id}
                            type={`checkbox`}
                            checked={item?.enabled_status.value}
                            value={item?.enabled_status}
                            className={`sr-only peer cursor-pointer`}
                            onClick={() => handleToggleUserActive(item)}
                          />
                          <div className={`mt-3 ml-4`}>
                            <div className={`${item?.enabled_status.value ? "" : "rotate-180"}`}>
                              {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="15"
                                viewBox="0 0 26 15"
                                fill="none"
                              >
                                <path
                                  d="M18.3182 0.777832H7.68182C3.43909 0.777832 0 3.91168 0 7.77783C0 11.644 3.43909 14.7778 7.68182 14.7778H18.3182C22.5609 14.7778 26 11.644 26 7.77783C26 3.91168 22.5609 0.777832 18.3182 0.777832Z"
                                  fill={item?.enabled_status.value ? "#0A63E9" : "#D1D5DB"} // Blue if checked, light grey if unchecked
                                />
                                <path
                                  d="M18.3182 13.7009C21.908 13.7009 24.8182 11.0491 24.8182 7.77783C24.8182 4.50661 21.908 1.85476 18.3182 1.85476C14.7283 1.85476 11.8182 4.50661 11.8182 7.77783C11.8182 11.0491 14.7283 13.7009 18.3182 13.7009Z"
                                  fill={item?.enabled_status.value ? "#E8F5E9" : "#E5E7EB"} // Light green if checked, light grey if unchecked
                                />
                              </svg> */}
                              {item?.enabled_status.value ? <ActiveIcon /> : <InActiveIcon />}
                            </div>
                          </div>
                          {/* {Boolean(quiFilter.external) && (
                            <button onClick={() => handleDeleteExternalUser(item)} className="ml-[10px] pt-2">
                              <DeleteIcon color={"red"} size={22} />
                            </button>
                          )} */}
                        </label>
                        <button
                          className={`ms-3`}
                          title="Edit"
                          onClick={() => handleEditModalClick(item?.customer_id?.value)}
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                      </div>
                    );
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {isPopupOpen && (
        <Dialog open={isPopupOpen} onClose={onClose}>
          <div className=" inset-0 flex items-center justify-center z-[102]">
            <AddUpdateDelegation closePopup={onClose} handleSubmitData={handelRegenerat} setAlert={setAlert} />
          </div>
        </Dialog>
      )}
      {editData && (
        <div className="fixed inset-0 flex items-center justify-center z-[102]">
          <AddUpdateDelegation
            closePopup={onClose}
            handleSubmitData={handelRegenerat}
            editData={editData}
            customerId={customerId}
          />
          {console.log("editData", editData)}
        </div>
      )}
    </Fragment>
  );
};

export default ManageAccess;
